module.exports = __webpack_public_path__ + "blue.webp?c9db95235915140826d57a4512dd5113";